
import { Vue, Component, Ref } from "vue-property-decorator";
import { ListDataSource } from "@/data/List/ListDataSource";
import DataEditorDialog from "@/components/helpers/data/editor-dialog.vue";
import AppForm from "@/components/app-form/app-form.vue";
import { Filter } from "@/cms-services/filter";
import DataList from "@/components/common/data/list.vue";
import moment from "moment";
import { mdiCheck, mdiClose } from "@mdi/js";
import userModule from "@/store/modules/user";
@Component({
  components: { AppForm, DataEditorDialog, DataList },
})
export default class Home extends Vue {
  @Ref("dataList") dataLsit!: DataList;
  @Ref("editor") editor!: DataEditorDialog;

  userModule = userModule;

  moment = moment;
  loaded = false;
  icons: any = {
    check: mdiCheck,
    close: mdiClose,
  };

  dataSource: any = new ListDataSource({
    config: {
      pageIndex: 1,
      pageSize: 15,
    },
    className: "DataBusResponseMessage",
  });

  profileDataSource: ListDataSource = new ListDataSource({
    className: "profile",
    config: {
      pageIndex: 1,
      pageSize: 3000,
    },
  });
  $confirm: any;
  $message: any;

  async created() {
    await this.profileDataSource.get();
    this.loaded = true;
  }

  createItemModel: any = {
    profileId: null,
  };

  createItemFields: any = [
    {
      editor: "enum",
      attrs: {
        label: "Пользователь",
        outlined: true,
      },
      name: "profileId",
      config: {
        getItems: "getProfiles",
        labelKeyName: "fullName",
        valueKeyName: "id",
        type: "select",
      },
    },
  ];

  customHeaders: any = [
    {
      text: "ID",
      value: "id",
      sortable: true,
    },
    {
      text: "Дата создания",
      value: "date",
      sortable: true,
    },
    {
      text: "Пользователь",
      value: "fullName",
      sortable: true,
    },
    {
      text: "Состояние",
      value: "state",
      sortable: false,
      align: "left",
    },
  ];

  editorFields: any = [
    {
      editor: "ace",
      name: "data",
      config: {
        lang: "json",
      },
    },
  ];

  get breadcrumbs() {
    return [
      {
        text: "Главная",
        to: "/",
      },
      {
        text: "Ответы",
        disabled: true,
      },
    ];
  }

  filterModel: any = {
    dateFrom: "",
    dateTo: "",
    profileId: "",
  };

  fileterFields: any = [
    {
      editor: "date",
      attrs: {},
      name: "dateFrom",
      grid: { cols: 4 },
      config: {
        attrs: {
          outlined: true,
          label: "От",
          appendIcon: "mdi-calendar",
        },
      },
    },
    {
      editor: "date",
      attrs: {},
      name: "dateTo",
      grid: { cols: 4 },
      config: {
        attrs: {
          outlined: true,
          label: "До",
          appendIcon: "mdi-calendar",
        },
      },
    },
    {
      editor: "auto-complete-select",
      attrs: {
        type: "text",
        outlined: true,
        label: "Выберите пользователя",
        noDataText: "Данные не найдены",
      },
      grid: { cols: 4 },
      name: "profileId",
      config: {
        getItems: "getProfiles",
        labelKeyName: "fullName",
        valueKeyName: "id",
        type: "select",
      },
    },
  ];

  async filterChanged() {
    this.dataSource.config.filter = Object.entries(this.filterModel)
      .filter(([key, value]) => !!value)
      .map(([key, value]) => new Filter(key, value as string))
      .toFilterString();

    await this.dataSource.get();
  }

  async remove(item) {
    const confirm = await this.$confirm({
      title: "Вы уверены что хотите удалить всё?",
      text: "Восстановление удаленных данных невозможно",
    });
    if (!confirm) return;
    try {
      await this.dataSource.remove(item.id);
      this.$message("Успешно удалено");
      await this.dataLsit.refreshData();
    } catch (error: any) {
      this.$message("Не удалось удалить", "error");
    }
  }

  actions: any = {
    getProfiles: () => this.profileDataSource.items,
  };

  async viewDataJson(item) {
    const data = JSON.stringify(item.data, null, 2);
    await this.$nextTick();
    await this.editor.update({ data });
  }
}
